export default __webpack_public_path__ + "static/living_image_one-bf6873c340dc717f1fcce30226c19839.jpg";